<div class="bii_container">
  <header>
    <h2>Batch Image Import</h2>
    <p>Powering Grid Digital Twin</p>
  </header>
  <div class="upload-file-area">
    <div (click)="showModal = true" class="upload-content">
      <div class="image-wrapper">
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.75 3.5C3.23122 3.5 2 4.73122 2 6.25V18.177C2 19.46 3.04005 20.5 4.32301 20.5H18.0047C19.2247 20.5 20.2988 19.6963 20.643 18.526L22.3436 12.7438C22.6408 11.7335 21.9874 10.7215 21 10.5317V9.25C21 7.73122 19.7688 6.5 18.25 6.5H12.5352C12.4516 6.5 12.3735 6.45822 12.3272 6.38867L11.2178 4.72457C10.7077 3.95953 9.8491 3.5 8.92963 3.5H4.75ZM19.5 10.5V9.25C19.5 8.55964 18.9404 8 18.25 8H12.5352C11.9501 8 11.4037 7.70757 11.0791 7.22073L9.9697 5.55662C9.73786 5.20888 9.34757 5 8.92963 5H4.75C4.05964 5 3.5 5.55964 3.5 6.25V18.177C3.5 18.6315 3.86848 19 4.32301 19C4.68811 19 5.00956 18.7595 5.11258 18.4092L6.85822 12.474C7.20244 11.3037 8.27655 10.5 9.49648 10.5H19.5Z"
            fill="var(--primary-color)"
            fill-opacity="0.7"
          />
        </svg>
      </div>
      <p class="upload-title">Upload file</p>
      <p class="upload-subtitle">JPG, PNG</p>
    </div>
  </div>
  <div class="table-wrapper">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th class="th-checkbox"><input type="checkbox" /></th>
            <th>Upload ID</th>
            <th>Date</th>
            <th>No. of Entries</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let history of histories">
            <td><input type="checkbox" /></td>
            <td>{{ history.guid }}</td>
            <td>{{ history.date | date:'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="no-wrap-cell">
              <div class="progress-wrapper">
                <div class="progress-container">
                  <div
                    class="progress-bar"
                    [style.width]="history.uploadProgressBarWidth + '%'"
                  ></div>
                </div>
                <span class="progress-text"
                  >{{ history.uploadedCount }}/{{ history.maxCount }}</span
                >
              </div>
            </td>
            <td>
              <span
                class="status"
                [ngClass]="{
                  green: history.status == 'Completed',
                  orange: history.status == 'In Progress'
                }"
                >{{ history.status }}</span
              >
            </td>
            <td><button class="process-btn active"(click)="processBatch(history.id)" >Process</button></td>
          </tr>
          <!-- <tr>
            <td><input type="checkbox" /></td>
            <td>713277952</td>
            <td>08/30/2024 09:33:10</td>
            <td class="no-wrap-cell">
              <div class="progress-wrapper">
                <div class="progress-container">
                  <div class="progress-bar" style="width: 47%"></div>
                </div>
                <span class="progress-text">92/192</span>
              </div>
            </td>
            <td><span class="status processing">Processing</span></td>
            <td><button class="process-btn disabled">Process</button></td>
          </tr> -->
        </tbody>
      </table>
      <div class="pagination">
        <lib-asset-list-pagination
          [pageFromList]="currentPage"
          (pageChanged)="onPageChange($event)"
          [totalItems]="count"
        ></lib-asset-list-pagination>
      </div>
    </div>
  </div>
</div>

<ng-template #overlayTemplate>
  <div (click)="closeModal($event)" class="ai-overlay">
    <div class="ai-modal">
      <div class="ai-modal-content">
        <h2>Upload File</h2>
        <span class="close-button" data-bs-dismiss="modal" (click)="closeModal($event)">x</span>
        <div class="ai-modal-select">
          <div
            (click)="isSelectVoltageOpen = !isSelectVoltageOpen"
            class="ai-modal-select-default"
          >
            <p>Select Feeder Voltage</p>
            <div>
              <svg
                width="14px"
                height="14px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z"
                  fill="#0F0F0F"
                />
              </svg>
            </div>
          </div>
          <div *ngIf="isSelectVoltageOpen" class="select-feeder">
            <div class="radio-wrapper first">
              <input
                type="radio"
                name="feederVoltage"
                [(ngModel)]="selectedVoltage"
                (ngModelChange)="onVoltageSelect($event)"
                value="33kV"
              /><span>33kV</span>
            </div>
            <div class="radio-wrapper">
              <input
                type="radio"
                name="feederVoltage"
                [(ngModel)]="selectedVoltage"
                (ngModelChange)="onVoltageSelect($event)"
                value="11kV"
              /><span>11kV</span>
            </div>
          </div>
        </div>
        <div class="ai-modal-select">
          <div
            (click)="isSelectFeederOpen = !isSelectFeederOpen"
            class="ai-modal-select-default"
          >
            <p>Feeder Name</p>
            <div>
              <svg
                width="14px"
                height="14px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z"
                  fill="#0F0F0F"
                />
              </svg>
            </div>
          </div>
          <div
            *ngIf="isSelectFeederOpen && selectedVoltage != ''"
            class="select-feeder feeder-name"
          >
            <div class="search-bar-wrapper">
              <input
                type="text"
                placeholder="Search Feeder Name"
                [(ngModel)]="searchText"
                (input)="filterFeeders()"
              />
            </div>
            <div class="feeders-list">
              <div *ngFor="let feeder of filteredFeeders" class="radio-wrapper">
                <input
                  type="radio"
                  name="feederName"
                  value="{{ feeder.id }}"
                  (click)="selectFeeder(feeder.id)"
                /><span>{{ feeder.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ai-modal-footer">
        <input
          type="file"
          webkitdirectory
          multiple
          style="display: none"
          (change)="onFolderSelected($event)"
          #folderInput
          class="mb-4"
        />
        <button type="button" [disabled]="selectedFeederId == 0" (click)="folderInput.click()">
          Proceed to select file
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="showModal">
  <ng-container *ngTemplateOutlet="overlayTemplate"></ng-container>
</ng-container>
